<template>
	<div class="title_bar is-flex is-align-items-center"
		:class="showTitle ? 'is-justify-content-space-between mb-4' : 'is-justify-content-flex-end mb-1'">
		<div v-if="showTitle" class="is-flex is-align-items-center">
			<Ecs class="mr-2" style="width: 20px; height: 20px;" />
			<span class="tittle_section">{{ title }}</span>
		</div>
		<div class="table_actions is-flex">
			<!-- Toggle tabla ↔ comparación, opt-in vía `comparisonEnabled`. Cuando
				está deshabilitado (modo contrapartes en Costos/Gastos, o tabs que
				no soportan comparación como Activos/No Operacional) NO se renderiza
				ninguna acción acá. Sin título el toggle va flush a la derecha. -->
			<button v-if="comparisonEnabled" class="action_btn"
				:class="[{ 'is-active': comparisonOpen }, { 'mr-2': showTitle }]"
				@click="$emit('toggle-comparison', !comparisonOpen)">
				<component :is="comparisonOpen ? 'DashboardSquare' : 'ChartLine'"
					class="mr-1" style="width: 16px; height: 16px;" />
				{{ comparisonOpen ? "Tabla" : "Comparación" }}
			</button>
			<div v-if="showPeriodSelect" style="min-width: 140px;">
				<SelectComponent :value="selectedPeriod" theme="report_theme"
					:options="periodOptions"
					@input="$emit('change-period', $event)" />
			</div>
		</div>
	</div>
</template>

<script>
import SelectComponent from "@/components/classification/SelectComponent";
import Ecs from "@/components/svg/Ecs.vue";
import ChartLine from "@/components/svg/ChartLine.vue";
import DashboardSquare from "@/components/svg/DashboardSquare.vue";

export default {
	name: "EvolutionTableTitleBar",

	components: { SelectComponent, Ecs, ChartLine, DashboardSquare },

	props: {
		title: { type: String, required: true },
		// Opt-out del título + ícono. Cuando false el bar queda fino y con las
		// acciones alineadas a la derecha (lo usa Gastos, que ya tiene un título
		// general arriba — replica el header delgado de Ventas).
		showTitle: { type: Boolean, default: true },
		selectedPeriod: { type: String, required: true },
		periodOptions: { type: Array, required: true },
		showPeriodSelect: { type: Boolean, default: true },
		// Opt-in: convierte el botón "Comparación" en un toggle real (emite
		// `toggle-comparison`). Sin esto se conservan los botones estáticos.
		comparisonEnabled: { type: Boolean, default: false },
		comparisonOpen: { type: Boolean, default: false },
	},
};
</script>

<style scoped lang="scss">
.tittle_section {
	font-size: 18px;
	font-weight: 600;
}

.action_btn {
	background: var(--report-bg);
	border: 1px solid var(--report-border);
	border-radius: 8px;
	padding: 6px 12px;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	cursor: pointer;

	&:hover { background: var(--report-surface); }

	// Activo mientras el panel de comparación está abierto.
	&.is-active {
		background: var(--report-accent-bg);
		border-color: var(--report-accent-border);
		color: var(--report-accent-text);
	}
}
</style>
